import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeAroundSecondaryContentItemContent$key } from "~/queries/__generated__/homeAroundSecondaryContentItemContent.graphql";

import { Container, Content, Headline, StyledEntityLink } from "./styles";

export type Props = {
  reference: homeAroundSecondaryContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeAroundSecondary = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeAroundSecondaryContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <Content>
            <Headline>
              {provider.headline({
                preferSocialHeadline: true,
                useContentSponsorStyle: false,
              })}
            </Headline>
          </Content>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemHomeAroundSecondary.displayName = "ContentItemHomeAroundSecondary";
